import React from "react";

import ReactExport from "react-data-export";

import ENUMS from "../../utils/ENUMS.js"

import moment from "moment";
const token = localStorage.getItem(ENUMS.AUTH);

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const Btn_green = ({incidents}) => {
    // const exportCSV=()=>{
    //     let courses = JSON.parse(localStorage.getItem("courses"))
    //
    //     if(!courses?.length) return toast.error("No courses available!")
    //
    //     const courseId= courses[0].id
    //     console.log(courseId,"jahjhb");
    //     axios({
    //         url: `${BASE_URL}/club/incident/download/?course_id=${courseId}`, //your url
    //         headers: { Authorization: `Bearer ${token}`},
    //         method: 'GET',
    //         responseType: 'blob', // important
    //     }).then((response) => {
    //         const url = window.URL.createObjectURL(new Blob([response.data]));
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.setAttribute('download', 'incidentlog.xls'); //or any other extension
    //         document.body.appendChild(link);
    //         link.click();
    //     });
    // }
    return (
        <>
            {/*<button    className="res-btn-lightgrn"*/}
            {/*        onClick={() => exportCSV() }*/}
            {/*>export to csv</button>*/}
            {/*<DownloadExcel*/}
            {/*    className="res-btn-lightgrn"*/}
            {/*    tableName={"incidentlog"}*/}
            {/*    className={'res-btn-lightgrn'}*/}
            {/*/>*/}
            <ExcelFile filename="incidents"
                       element={
                           (
                               <button type="button"   className="res-btn-lightgrn">export to csv</button>
                           )
                       }
            >
                <ExcelSheet data={incidents} name="INCIDENTS">
                    <ExcelColumn style={{width: {wpx: 80}}} label="NUMBER" value="id"/>
                    <ExcelColumn style={{width: {wpx: 200}}}  label="DATE"
                                 value={(col) => moment(col.created_at.split('T')[0]).format('DD-MM-YY')} />
                    <ExcelColumn style={{width: {wpx: 200}}}  label="TIME LOGGED"
                                 value={(col) => col.created_at.split('T')[1].split('.')[0]} />
                    <ExcelColumn   label="AREA LOGGED"
                                 value={(col) =>`HOLE ${col.holepoint.hole_index}`} />

                    <ExcelColumn label="INCIDENT TYPE"
                                 value={(col) => col.incident.label }/>
                    <ExcelColumn label="NOTES" value="notes"/>
                    <ExcelColumn label="LOGGED BY"
                                 value={(col) => col.user.full_name }/>
                    <ExcelColumn label="RESOLVE ISSUE"
                                 value={(col) => col.status.label }/>

                </ExcelSheet>

            </ExcelFile>


        </>
    );
};
export default Btn_green;
